/*
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-07 15:13:15
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-05-28 16:26:05
 * @FilePath: \knowledge-graph\src\router\modules\Base.js
 * @Description: 路由构建
 */
const needLayout = []
const modulesFiles = require.context('../../views', true, /\.vue$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
let layoutRoutes = []
const needLayoutRoute = []
Object.keys(modules).forEach(key => {
  const path = key.split('/')
  if (needLayout.includes(path[0])) {
    const row = needLayoutRoute.find(e => e.name === path[0])
    if (row) {
      row.children = row.children.concat({
        path: `${path[1]}`,
        component: modules[key],
        name: modules[key].name,
        meta: modules[key].meta
      })
    } else {
      needLayoutRoute.push({
        path: `/${path[0]}`,
        component: () => import('@/layout/index.vue'),
        name: path[0],
        children: [{
          path: `${path[1]}`,
          component: modules[key],
          name: modules[key].name,
          meta: modules[key].meta
        }]
      })
    }
  } else {
    layoutRoutes = layoutRoutes.concat({
      path: `${path[1]}`,
      component: modules[key],
      name: modules[key].name,
      meta: modules[key].meta
    })
  }
})
export default [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    children: layoutRoutes
  },
  ...needLayoutRoute
]
